import { PlanTypes } from '@gonfalon/billing/types';

import type { Plan } from '../../../plan/types';

import { developer2025Plan } from './developer2025Plan';
import { developerPlan } from './developerPlan';
import { foundation2025Plan } from './foundation2025Plan';
import { foundation2025PlanPostTrial } from './foundation2025PlanPostTrial';
import { foundationPlan } from './foundationPlan';
import { foundationPlanPostTrial } from './foundationPlanPostTrial';
import { guardianPlan } from './guardianPlan';
import type { CatalogPlanId } from './planIds';

export const planIdToPlan = {
  [`${PlanTypes.FOUNDATION2023}-developer`]: developerPlan,
  [`${PlanTypes.FOUNDATION2023}`]: foundationPlan,
  [`${PlanTypes.GUARDIAN2024}`]: guardianPlan,
  [`${PlanTypes.FOUNDATION2023}-post-trial`]: foundationPlanPostTrial,
  [`${PlanTypes.DEVELOPER2025}`]: developer2025Plan,
  [`${PlanTypes.FOUNDATION2025}`]: foundation2025Plan,
  [`${PlanTypes.FOUNDATION2025}-post-trial`]: foundation2025PlanPostTrial,
} as const satisfies Record<CatalogPlanId, Plan>;
